import { j as e, a as p } from "../../../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import n from "../../../../string-table.js";
import "@ionic/react";
import "../../../../../FeatureFlagProvider-DSFeeZ8R.js";
import "react";
import "../../../../../react-paginate-Lh5zQzpz.js";
import { Section as E } from "../Section/Section.js";
import "../../../LoadingInterstitial/LoadingInterstitial.js";
import "../../../../contexts/DesignSystemProvider/DesignSystemProvider.js";
import '../../../../../css/SwingExperience.css';const i = "_experienceWrapper_18eah_1", S = "_statWrapper_18eah_10", u = "_flexStart_18eah_17", m = "_spaceBetween_18eah_22", I = "_statCount_18eah_26", R = "_statLabel_18eah_31", s = {
  experienceWrapper: i,
  statWrapper: S,
  flexStart: u,
  spaceBetween: m,
  statCount: I,
  statLabel: R
};
function B(t) {
  const {
    daysWorked: a,
    schoolsWorked: r,
    timesPreferred: o,
    positiveReviews: l
  } = t, c = h(t) === 2;
  return /* @__PURE__ */ e(E, {
    title: n("SUB_PROFILE_SWING_EXPERIENCE_HEADER"),
    children: /* @__PURE__ */ e("div", {
      children: /* @__PURE__ */ p("ul", {
        className: `${s.experienceWrapper} ${c ? s.flexStart : s.spaceBetween}`,
        children: [!!a && /* @__PURE__ */ e(_, {
          label: n("SUB_PROFILE_SWING_EXPERIENCE_DAYS_WORKED"),
          statCount: a
        }), !!r && /* @__PURE__ */ e(_, {
          label: n("SUB_PROFILE_SWING_EXPERIENCE_SCHOOLS_WORKED"),
          statCount: r
        }), !!o && /* @__PURE__ */ e(_, {
          label: n("SUB_PROFILE_SWING_EXPERIENCE_TIMES_PREFERRED"),
          statCount: o
        }), !!l && /* @__PURE__ */ e(_, {
          label: n("SUB_PROFILE_SWING_EXPERIENCE_POSITIVE_REVIEWS"),
          statCount: l
        })]
      })
    })
  });
}
function W(t) {
  return t.split(" ").map((a, r, o) => r < o.length - 1 ? `${a} <br />` : a).join(" ");
}
function h(t) {
  return Object.values(t).length;
}
function _(t) {
  const {
    label: a,
    statCount: r
  } = t;
  return /* @__PURE__ */ p("li", {
    className: s.statWrapper,
    children: [/* @__PURE__ */ e("span", {
      className: s.statCount,
      children: r
    }), /* @__PURE__ */ e("span", {
      dangerouslySetInnerHTML: {
        __html: W(a)
      },
      className: s.statLabel
    })]
  });
}
export {
  B as SwingExperience
};
